import Css from "../../style.module.scss";

import { FormElement } from "nlib/common/Form";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Checkbox from "nlib/ui/Checkbox";
import FormContext from "contexts/FormContext";
import MinAmountForAttachment from "./lib/MinAmountForAttachment";
import React, { useContext } from "react";
import classNames from "classnames";

const AiBookkeeperTabDocuments = ({ disabled }) => {
  const { messages } = useSelector(getTextsData);

  const { values: { rpaAmountDocumentRuleToggle } } = useContext(FormContext);

  return (
    <>
      <div className={Css.row}>
        <FormElement
          toggle
          name="rpaPayeeDocumentRule"
          element={Checkbox}>{messages.rpaPayeeDocumentRule}</FormElement>
        <div className={Css.description}>{messages.rpaPayeeDocumentRuleDescription}</div>
      </div>
      <div className={classNames(Css.row, rpaAmountDocumentRuleToggle && Css.rowWithRelatedContent)}>
        <FormElement
          toggle
          name="rpaAmountDocumentRuleToggle"
          element={Checkbox}>
          {messages.rpaAmountDocumentRule}
        </FormElement>
        <div className={Css.description}>{messages.rpaAmountDocumentRuleDescription}</div>
      </div>
      {rpaAmountDocumentRuleToggle && (
        <div className={classNames(Css.row, Css.toggleRelatedContent)}>
          <div className={Css.col}>
            <div className={Css.relatedInputLabel}>{messages.rpaMinTransactionAmountLabel}</div>
            <FormElement
              readOnly={disabled}
              name="rpaAmountDocumentRule"
              element={MinAmountForAttachment} />
          </div>
        </div>
      )}
    </>
  );
};

export default AiBookkeeperTabDocuments;
